export default __webpack_public_path__ + "static/fluids-a1f9fde144f4f234a494adc2de837777.png";